import React, { useState } from "react";
import {
  X,
  Calendar,
  Upload,
  AlertCircle,
  CircleCheck,
  CircleX,
} from "lucide-react";
import "../../styles/Task/TaskDrawer.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MOCK_USERS = [
  { id: 1, name: "John Doe", avatar: "https://i.pravatar.cc/30?img=1" },

  { id: 2, name: "Jane Smith", avatar: "https://i.pravatar.cc/30?img=2" },

  { id: 3, name: "Mike Johnson", avatar: "https://i.pravatar.cc/30?img=3" },
];

const CATEGORIES = [
  "Competitive Analysis",

  "Customers",

  "Products",

  "Brand Assets",
];

function TaskDrawer({ isOpen, onClose, onSubmit ,isEdit= false }) {
  const [taskData, setTaskData] = useState({
    title: "",

    status: "TO DO",

    assignees: [],

    dueDate: null,

    category: [],

    impact: "Low",

    effort: "30 min", // Default value

    priority: "Highest",

    description: "",

    documents: [],
  });

  const [showAssigneeDropdown, setShowAssigneeDropdown] = useState(false);

  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit(taskData);
    console.log(taskData);

    onClose();
  };

  const handleFileUpload = (e) => {
    const files = e.target.files;

    if (files) {
      setTaskData((prev) => ({
        ...prev,

        documents: [...prev.documents, ...Array.from(files)],
      }));
    }
  };

  const handleAssigneeSelect = (user) => {
    setTaskData((prev) => ({
      ...prev,

      assignees: [...prev.assignees, user],
    }));

    setShowAssigneeDropdown(false);
  };

  const removeAssignee = (userId) => {
    setTaskData((prev) => ({
      ...prev,

      assignees: prev.assignees.filter((a) => a.id !== userId),
    }));
  };

  const handleCategorySelect = (category) => {
    setTaskData((prev) => ({
      ...prev,

      category: [...prev.category, category],
    }));

    setShowCategoryDropdown(false);
  };

  const removeCategory = (category) => {
    setTaskData((prev) => ({
      ...prev,

      category: prev.category.filter((c) => c !== category),
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="drawer-overlay">
      <div className="drawer mx-2">
        <div className="drawer-header">
          <div className="preheader d-flex justify-content-start align-items-center gap-3">
            <button style={{ width: '15px', height:'15px' }} className="btn-close" onClick={onClose}>
            </button>
          <p > { !isEdit ? "Add New Task" :"Edit task"} </p>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <input
              type="text"
              className="form-control task-title-input"
              placeholder="New task title"
              value={taskData.title}
              onChange={(e) =>
                setTaskData((prev) => ({ ...prev, title: e.target.value }))
              }
            />
          </div>
        </div>

        <div className="drawer-body">
          <div className="row mb-1">
            <div className="col-6">
              <label>Status</label>
            </div>
            <div className="col-6">
              <select
                className="form-select status-select"
                value={taskData.status}
                onChange={(e) =>
                  setTaskData((prev) => ({ ...prev, status: e.target.value }))
                }
              >
                <option value="TO DO">TO DO</option>
                <option value="IN PROGRESS">IN PROGRESS</option>
                <option value="DONE">DONE</option>
              </select>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-6">
              <label>Assignees</label>
            </div>
            <div className="col-6">
              <div className="assignee-wrapper">
                {taskData.assignees.length > 0 ? (
                  <div className="selected-assignees">
                    {taskData.assignees.map((user) => (
                      <div key={user.id} className="assignee-tag">
                        <img src={user.avatar} alt={user.name} />
                        <span>{user.name}</span>
                        <X
                          size={14}
                          className="cursor-pointer"
                          onClick={() => removeAssignee(user.id)}
                        />
                      </div>
                    ))}
                    <button
                      className="add-more-btn"
                      onClick={() =>
                        setShowAssigneeDropdown(!showAssigneeDropdown)
                      }
                    >
                      + Add more
                    </button>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <img src="/assignee.svg" alt="" height={30} width={50} />
                    <input
                      type="text"
                      className="assignee-input"
                      placeholder="Unassigned"
                      readOnly
                      onClick={() =>
                        setShowAssigneeDropdown(!showAssigneeDropdown)
                      }
                    />
                  </div>
                )}

                {showAssigneeDropdown && (
                  <div className="assignee-dropdown">
                    {MOCK_USERS.filter(
                      (user) =>
                        !taskData.assignees.find((a) => a.id === user.id)
                    ).map((user) => (
                      <div
                        key={user.id}
                        className="assignee-option"
                        onClick={() => handleAssigneeSelect(user)}
                      >
                        <img src={user.avatar} alt={user.name} />
                        <span>{user.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-6">
              <label>Due date</label>
            </div>
            <div className="col-6">
              <div className="date-picker-wrapper">
                <DatePicker
                  selected={taskData.dueDate}
                  onChange={(date) =>
                    setTaskData((prev) => ({ ...prev, dueDate: date }))
                  }
                  dateFormat="dd/MM/yyyy"
                  placeholderText="dd/mm/yyyy"
                  className="date-input"
                  customInput={
                    <div className="d-flex align-items-center">
                     
                      <input 
                     style={{ width: '75px' }}
                        value={
                          taskData.dueDate
                            ? taskData.dueDate.toLocaleDateString("en-GB")
                            : ""
                        }
                        readOnly
                        placeholder="dd/mm/yyyy"
                      /> <Calendar size={15} className="me-2" />
                    </div>
                  }
                />
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-6">
              <label>Category</label>
            </div>
            <div className="col-6">
              <div className="category-wrapper">
                <div className="category-tags">
                  {taskData.category.map((cat) => (
                    <span key={cat} className="category-tag">
                      {cat}
                      <X
                        size={14}
                        className="ms-2 cursor-pointer"
                        onClick={() => removeCategory(cat)}
                      />
                    </span>
                  ))}
                  <button
                    className="add-more-btn"
                    onClick={() =>
                      setShowCategoryDropdown(!showCategoryDropdown)
                    }
                  >
                    + Add more
                  </button>
                </div>

                {showCategoryDropdown && (
                  <div className="category-dropdown">
                    {CATEGORIES.filter(
                      (cat) => !taskData.category.includes(cat)
                    ).map((category) => (
                      <div
                        key={category}
                        className="category-option"
                        onClick={() => handleCategorySelect(category)}
                      >
                        {category}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-6">
              <label>Impact</label>
            </div>
            <div className="col-6">
              <select
                className="form-select impact-select impact-low"
                value={taskData.impact}
                onChange={(e) =>
                  setTaskData((prev) => ({ ...prev, impact: e.target.value }))
                }
              >
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
              </select>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-6">
              <label>Effort</label>
            </div>
            <div className="col-6">

<input

  type="text"

  className="form-control"

  placeholder="e.g., 30 min"

  value={taskData.effort}

  onChange={(e) =>

    setTaskData((prev) => ({ ...prev, effort: e.target.value }))

  }

/>

</div>
          </div>

          <div className="row mb-1">
            <div className="col-6">
              <label>Priority</label>
            </div>
            <div className="col-6">
              <div className="d-flex align-items-center">
                <select
                  className="form-select priority-select"
                  value={taskData.priority}
                  onChange={(e) =>
                    setTaskData((prev) => ({
                      ...prev,
                      priority: e.target.value,
                    }))
                  }
                >
                  <option value="Highest">Highest</option>
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </select>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              className="form-control mt-2"
              rows={4}
              placeholder="Describe the task in a clear and concise way. For example: Complete initial research and draft a proposal."
              value={taskData.description}
              onChange={(e) =>
                setTaskData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>

          <div className="form-group">
            <label>Upload documents</label>
            <div className="upload-area mt-2">
              <input
                type="file"
                id="file-upload"
                multiple
                className="d-none"
                onChange={handleFileUpload}
              />
              <label htmlFor="file-upload" className="upload-box">
                <Upload size={24} />
                <p>Drag and drop files, or Browse</p>
                <small>Supported formats: PDF, DOC, XLS, PPT, ZIP</small>
              </label>
              {taskData.documents.length > 0 && (
                <div className="uploaded-files">
                  {taskData.documents.map((file, index) => (
                    <div key={index} className="uploaded-file border">
                      <img
                        src="/pdf.svg"
                        className="img-fluid upload-img-task"
                      />
                      <span>
                        {file.name.length > 10
                          ? `${file.name.slice(0, 30)}...`
                          : file.name}
                      </span>
                      <button
                        className="btn-remove btn"
                        onClick={() => {
                          setTaskData((prev) => ({
                            ...prev,
                            documents: prev.documents.filter(
                              (_, i) => i !== index
                            ),
                          }));
                        }}
                      >
                        <CircleX size={18} color="var(--primary)" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="drawer-footer">
          <button className="btn btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-create-task" onClick={handleSubmit}>
            Create task
          </button>
        </div>
      </div>
    </div>
  );
}

export default TaskDrawer;
